import {ModalWithNewForm, EitjeButton, Select} from '~/components'
import {Input} from '@eitje/web_components'
import {useParams} from '@eitje/bridge'
import {Environment} from '@eitje/api'
import {goBack} from '~/routing/actions'

const STATUS_ITEMS = [
	{id: 'active', t: 'common.status.active'},
	{id: 'eitje', t: 'common.status.eitje'},
	{id: 'inactive', t: 'common.status.inactive'},
]

export const EditEnvironment = () => {
	const {id} = useParams()

	const environment = Environment.useFind(id, {joins: ['organisations']})
	const {naam, status, organisation} = environment

	const currentStatusItem = {id: status, t: `common.status.${status}`}
	const statusItems = _.uniqBy([...STATUS_ITEMS, currentStatusItem], 'id')

	const handleSubmit = async ({naam, status}) => {
		const isValidStatus = _.includes(STATUS_ITEMS._map('id'), status)
		const updateParams = {naam, ...(isValidStatus && {status})}
		return await environment.update(updateParams)
	}

	return (
		<ModalWithNewForm
			name="edit_environment"
			onSubmit={handleSubmit}
			afterSubmit={goBack}
			modalProps={{
				okButtonProps: {t: 'common.save'},
				buttons: [
					<EitjeButton iconLeft="link" t="modals.edit_environment.change_button" modalLink={`/firms/environments/${id}/migrate`} />,
				],
				hideCancel: true,
			}}
			width={348}
			initialValues={{naam, status, organisation: organisation.name}}
		>
			<Input field="naam" required />
			<Select field="status" items={statusItems} required />
			<Input field="organisation" value={organisation} readOnly />
		</ModalWithNewForm>
	)
}
